// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3a-0O","top":"styles_top__1EUqf"};